var React = require('react');

function Linedry (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Desktop---Phase-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"Ikoner/Line-dry","transform":"translate(-2.384 -1.842)","stroke":"#000","strokeWidth":"2"},[React.createElement("path",{"d":"M3.557 3.557v32.886h32.886V3.557H3.557z","id":"Rectangle-21","key":0}),React.createElement("path",{"d":"M3.686 3.557c1.012 3.918 7.866 7.184 16.308 7.184 8.44 0 15.295-3.266 16.307-7.184H3.686z","id":"Oval-6","key":1})])));
}

Linedry.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36"};

module.exports = Linedry;

Linedry.default = Linedry;
